/**
 * @file   公共头部
 * @create macaiqi 2021/11/25
 * @update
 */
import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom'
import Login from './Login';
import cls from 'classnames';
import $ from 'jquery';
import './index.scss';
// 头部
const Header = () => {
  const { pathname } = useLocation()
  const headnav = [
    {
      name: '知识百科',
      channel: '/Subject/AncientConstruct'
    },
    {
      name: '影像探索',
      channel: '/PicturelistPage'
    },
    {
      name: '关系图谱',
      channel: '/KnowledgeRetrieval'
    },
    {
      name: '时空地图',
      channel: '/fullpage.html#firstPage'
    },
    {
      name: '知识大数据',
      channel: '',
      childs: [
        {name:'知识宇宙',channel:'/knowledgeUniverse.html'},
        {name:'堂号词云',channel:'/worldCloud.html'},
        {name:'牌坊形制',channel:'/pyramid.html'},
        {name:'棠樾古村形态演变',channel:'/morphologicalChange.html'}
      ]
    },
    {
      name: '智能问答',
      channel: '/Question'
    },
  ]
  return (
    <div className={cls("header",{'hideHeader':pathname.includes('Relation')})}>
      <div className="allcenter">
        <Link to='/' className="l" />

        <div className="head-r">
          <div className="nav" id='headNav'>
            {headnav.map((item, index) => {
              let childs = item.childs ?
              item.childs.map((el,index1) => {
                return (
                  <NavLink to={el.channel} key={index1} target='_blank'>
                    {el.name}
                  </NavLink>
                )
              }) 
              : <div/>;
              let html = item.channel ?
              <NavLink to={item.channel} className={cls("item", { 'active': item.name === '知识百科' & pathname?.includes('KnowledgeSearch') })} key={index} target='_blank'>
                {item.name}
                {item.childs ? <div className='childs'>{childs}</div> : ''}
              </NavLink>
              :
              <span className={cls("item", { 'active': item.name === '知识百科' & pathname?.includes('KnowledgeSearch') })} key={index}>
                <i onMouseEnter={()=>{
                  $('#headNav .item').eq(index).find('.childs').css('display','block');
                }}>{item.name}</i>
                {item.childs ? <div className='childs' onMouseLeave={()=>{
                  $('#headNav .item').eq(index).find('.childs').css('display','none');
                }}>{childs}</div> : ''}
              </span>
              return (html)
            })}
          </div>
          <Login />
        </div>
      </div>
    </div>
  )
};

export default Header;
